import React, { useEffect } from 'react'
import { GlobalBox } from 'components/Box/GlobalBox'
import { Grid, Box, Autocomplete, Chip, TextField, Typography } from '@mui/material';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { putConfigChange, setConfigChangeFilters } from "redux/actions/configChange/configChangeActions";
import { ModalV2 } from 'components/Modal/ModalV2';
import { useToggle } from "hooks/useToggle";
import { PERMISSIONS } from "router/permissions";

export const ConfigChange = () => {
    const { rules } = useSelector(({ login }) => login);
    const { stationsList } = useSelector(({ companies }) => companies);
    const state = useSelector(state => state['configChange']);
    const [open, setOpen] = useToggle();
    const { SUPPORT_SGC_CHANGE_CONF } = PERMISSIONS;
    const dispatch = useDispatch();

    const handleChange = (target) => {
        if (target.value === '' || Number(target.value) >= 0) {
            dispatch(setConfigChangeFilters(target.name, target.value));
        }
    }

    const handleOnSubmit = () => {
        const body = {
            idStation: state.station.id,
            serie: state.serie,
            stationary: state.stationary
        }
        dispatch(putConfigChange(body, setOpen))
    }

    useEffect(() => {
        dispatch(setConfigChangeFilters('serie', ''));
        dispatch(setConfigChangeFilters('stationary', ''));
    }, [state?.station])

    return (
        <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center", }}>
            <Grid item xs={12} md={8} lg={4} >
                <GlobalBox title="Cambio de configuraciones" icon={<PriceChangeIcon />} >
                    <Box
                        style={{
                            marginTop: 32,
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 16
                        }}
                    >
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={12}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={stationsList}
                                    value={state?.station || null}
                                    defaultValue={stationsList[0] || null}
                                    getOptionLabel={option => option?.label || ""}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                variant="outlined"
                                                label={option.label}
                                                {...getTagProps({ index })}
                                                style={{
                                                    borderRadius: 4
                                                }}
                                            />
                                        ))
                                    }
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Planta"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )}
                                    fullWidth
                                    onChange={(e, v) => dispatch(setConfigChangeFilters("station", v))}
                                    noOptionsText="No se encuentra la planta"
                                />
                            </Grid>
                            {state?.station &&
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Serie"
                                            type="number"
                                            name="serie"
                                            value={state?.serie}
                                            variant="outlined"
                                            required
                                            fullWidth
                                            onChange={({ target }) => {
                                                if (state?.[target.name] !== target.value) {
                                                    handleChange(target)
                                                }
                                            }}
                                            size="small"
                                            inputProps={{ min: 0 }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Estacionario"
                                            type="number"
                                            name="stationary"
                                            value={state?.stationary}
                                            variant="outlined"
                                            required
                                            fullWidth
                                            onChange={({ target }) => {
                                                if (state?.[target.name] !== target.value) {
                                                    handleChange(target)
                                                }
                                            }}
                                            size="small"
                                            inputProps={{ min: 0 }}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12} sm={12} display="flex" justifyContent='center' >
                                <RegularButton
                                    color="info"
                                    onClick={setOpen}
                                    disabled={!state?.station}
                                >
                                    Cambiar
                                </RegularButton>
                            </Grid>
                        </Grid>
                    </Box>
                </GlobalBox>
            </Grid>
            <ModalV2 title="Cambiar configuración?"
                open={open}
                onClose={setOpen}
                justConfirm
                onSubmit={handleOnSubmit}
            >
                <Grid item xs={12} sm={12} >
                    <Typography variant="subtitle1">Planta: {state?.station?.name}</Typography>
                    <Typography variant="subtitle1">Serie: {state.serie}</Typography>
                    <Typography variant="subtitle1">Estacionario: {state.stationary}</Typography>
                </Grid>
            </ModalV2>
        </Grid>
    )
}
